import { render, staticRenderFns } from "./OnboardingCustomizeEmail.vue?vue&type=template&id=5c0bd0e8"
import script from "./OnboardingCustomizeEmail.vue?vue&type=script&lang=js"
export * from "./OnboardingCustomizeEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports